var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_244_54799",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 30C23.7843 30 30.5 23.2843 30.5 15C30.5 6.71573 23.7843 0 15.5 0C7.21573 0 0.5 6.71573 0.5 15C0.5 23.2843 7.21573 30 15.5 30Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.25C9.08579 14.25 8.75 14.5858 8.75 15C8.75 15.4142 9.08579 15.75 9.5 15.75V14.25ZM21.5 15.75C21.9142 15.75 22.25 15.4142 22.25 15C22.25 14.5858 21.9142 14.25 21.5 14.25V15.75ZM14.75 21C14.75 21.4142 15.0858 21.75 15.5 21.75C15.9142 21.75 16.25 21.4142 16.25 21H14.75ZM16.25 9C16.25 8.58579 15.9142 8.25 15.5 8.25C15.0858 8.25 14.75 8.58579 14.75 9H16.25ZM16.25 21V9H14.75V21H16.25ZM9.5 15.75H15.5V14.25H9.5V15.75ZM15.5 15.75H21.5V14.25H15.5V15.75ZM29 15C29 22.4558 22.9558 28.5 15.5 28.5V31.5C24.6127 31.5 32 24.1127 32 15H29ZM15.5 28.5C8.04416 28.5 2 22.4558 2 15H-1C-1 24.1127 6.3873 31.5 15.5 31.5V28.5ZM2 15C2 7.54416 8.04416 1.5 15.5 1.5V-1.5C6.3873 -1.5 -1 5.8873 -1 15H2ZM15.5 1.5C22.9558 1.5 29 7.54416 29 15H32C32 5.8873 24.6127 -1.5 15.5 -1.5V1.5Z",
    fill: "#121212",
    fillOpacity: 0.5,
    mask: "url(#path-1-inside-1_244_54799)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadDark);
export default __webpack_public_path__ + "static/media/icon-upload-dark.c0f50cf054b8ad25296b802fea1eac65.svg";
export { ForwardRef as ReactComponent };